/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Rain_Showers_HeavyInputs */

const en_ui_weather_rain_showers_heavy = /** @type {(inputs: Ui_Weather_Rain_Showers_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy rain showers`)
};

const de_ui_weather_rain_showers_heavy = /** @type {(inputs: Ui_Weather_Rain_Showers_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heftige Regenschauer`)
};

/**
* | output |
* | --- |
* | "Heavy rain showers" |
*
* @param {Ui_Weather_Rain_Showers_HeavyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_rain_showers_heavy = /** @type {((inputs?: Ui_Weather_Rain_Showers_HeavyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Rain_Showers_HeavyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_rain_showers_heavy(inputs)
	return de_ui_weather_rain_showers_heavy(inputs)
});